<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in filterLink"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { computed, provide, ref } from '@vue/composition-api'
import useRoleStore from '@/store-pinia/useRoleStore'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    provide('openGroups', ref([]))
    // console.log('ver', props.items)
    const roleStore = useRoleStore()
    // const foundIndex = props.items.findIndex(item => item.route === 'ticket')
    // console.log('ticket route', foundIndex)

    const filterLink = computed(() => {
      if (!roleStore.canUserViewTicket) {
        const filterRes = props.items.filter(item => item.route !== 'ticket')
        // console.log('filter', filterRes)
        return filterRes
      }

      return props.items
    })
    return {
      resolveNavItemComponent,
      filterLink,
    }
  },
}
</script>
